/* eslint-disable */
import { catFetchGet } from './base/catFetchClient';

export type CommunityEntity = {
    value: string
    label: string
}

export const getCommunityEntities = async () => {
    return await catFetchGet('weeklylog/getCommunityEntities');
}